/*
  In order to release a help button menu quickly (upon request from), HelpDropdown is a copy/pasted component from AccountDropdown.js

  Unfortunately, this inherits any inefficiencies from AccountDropdown but the anticipated trade off was near-full themed CSS support for desktop to mobile resolutions.
*/
import React, { PureComponent } from 'react';
import { strings } from 'APP_ROOT/localization';
import globals from 'APP_ROOT/components/common/globals';
export default class HelpDropdown extends PureComponent {

    constructor(props) {

        super(props);

        this.state = {
            active: false
        }
    }

    componentDidMount() {

        window.addEventListener('click', this.onBlur);
    }

    componentWillUnmount() {

        window.removeEventListener('click', this.onBlur);
    }

    toggleActive = (e) => {

        e.preventDefault();
        this.setState({
            active: !this.state.active
        })
    }

    onBlur = (e) => {

        if (e.target !== this.ref && e.target.parentElement !== this.ref) {
            this.setState({
                active: false
            })
        }
    }

    render() {

        var btnClasses = [
            'btn-help',
            'btn-dropdown'
        ]

        if (this.state.active) btnClasses.push('active');

        return (
            <span>
                <button
                    className={btnClasses.join(' ')}
                    onClick={this.toggleActive}
                    onBlur={this.onBlur}
                    ref={ref => { this.ref = ref; }}
                >
                    <i className="material-icons">help</i>
                </button>
                <span className="help-menu">
                    <h4>{strings.help_menu_title}</h4>
                    <ExternalLink href={globals.fleetManagersGuideUrl}>{strings.help_menu_fleet_guide}</ExternalLink>
                    <hr />
                    <ExternalLink href={globals.supportUrl}>{strings.help_menu_help_centre}</ExternalLink>
                    <ExternalLink href={globals.installingRavenGuideUrl}>{strings.help_menu_installing_raven}</ExternalLink>
                    <hr />
                    <ExternalLink href={"mailto:" + globals.supportEmail}>{strings.help_menu_feedback}</ExternalLink>
                    {globals.buyRavenUrl ?
                        <ExternalLink href="https://ravenconnected.com/pricing">{strings.help_menu_buy_raven}</ExternalLink>
                    :
                        null
                    }
                </span>
            </span>
        )
    }
}

const ExternalLink = ({ children, ...anchorProps }) => (
    <a
        target='_blank'
        className='btn-help-link'
        rel='noopener noreferrer'
        {...anchorProps}
    >
        {children}
    </a>
);
